module.exports = __webpack_public_path__ + "static/media/logout.01ed395c.svg";